<mng-dialog-header title="Tastenkürzel" iconName="keyboard">
  <button mat-icon-button color="accent" (click)="close()">
    <mat-icon svgIcon="close" /></button
></mng-dialog-header>

<mat-dialog-content>
  @if (hotkeyList.length === 0) {
    <p>Auf dieser Seite stehen keine Tastenkürzel zur verfügung.</p>
  }
  <mat-list>
    @for (hotkey of hotkeyList; track hotkey.key) {
      <mat-list-item style="height: 48px">
        <mng-hotkey [hotkey]="hotkey" />
      </mat-list-item>
    }

    <mat-divider style="margin: 8px 0" />

    @for (hotkey of browserHotkeys; track hotkey.key) {
      <mat-list-item style="height: 48px">
        <mng-hotkey [hotkey]="hotkey" />
      </mat-list-item>
    }
  </mat-list>
</mat-dialog-content>
